import React from "react"

import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react"

import { TableHead } from "@/components/ui/table"
import { cn } from "@/lib/utils"

interface SortableTableHeadProps {
  column: string
  sortColumn: string | null
  sortDirection: "asc" | "desc"
  onSort: (column: string) => void
  align?: "left" | "center" | "right"
  className?: string
  children: React.ReactNode
}

const SortableTableHead: React.FC<SortableTableHeadProps> = ({
  column,
  sortColumn,
  sortDirection,
  onSort,
  align = "left",
  className,
  children,
}) => {
  return (
    <TableHead
      className={cn(
        className,
        "text-xs",
        align === "center" && "text-center",
        align === "right" && "text-right",
        "cursor-pointer hover:bg-palette-jungleGreen100/80 select-none",
      )}
      onClick={() => onSort(column)}
    >
      <div
        className={cn(
          "flex items-center",
          align === "center" && "justify-center",
          align === "right" && "justify-end",
          "gap-1",
        )}
      >
        {children}
        {sortColumn === column ? (
          sortDirection === "asc" ? (
            <ArrowUp size={12} />
          ) : (
            <ArrowDown size={12} />
          )
        ) : (
          <ArrowUpDown size={12} className="text-palette-jungleGreen400 opacity-60" />
        )}
      </div>
    </TableHead>
  )
}

export default SortableTableHead
